import { Action, ActionType } from "app/actions";
import { CurrentUser } from "app/shared/model/CurrentUser";
import * as api from 'app/shared/api';

function readCurrentUser(pageDto: PageDto) : CurrentUser {
    const userDto = pageDto.user || {};
    const currentUser : CurrentUser = {
        email: userDto.email || '',
        fullName: userDto.fullName || '',
        initials: userDto.initials || '??',
        permissionList: userDto.permissionList || [],
        monthsThreshold: userDto.monthsThreshold || 0
    };
    return currentUser;
}

type PageDto = {
    user?: {
        fullName?: string,
        initials?: string,
        email?: string,
        permissionList?: string[],
        monthsThreshold?: number
    },
    version?: string
}

export async function getStartupAction(): Promise<Action> {
    try {
        const user = await api.getCurrentUser();
        const pageDto = user as PageDto;

        const startupAction: Action = {
            type: ActionType.Startup,
            user: readCurrentUser(pageDto),
            version: pageDto.version || ''
        };

        return startupAction;
    } catch (error) {
        const unauthorizedAction: Action = {
            type: ActionType.Unauthorized
        };

        return unauthorizedAction;
    }
}